import * as yup from "yup";
import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../../components/ui/button";
import Common from "../../../../helper/common";
import {
  FormikInput,
  FormikCheckbox,
} from "../../../../components/formik-components";
import { respEnum } from "../../../../constants/appConstant";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";

const FormikInitialValues = {
  name: "",
  isactive: true,
};

const formikValidation = yup.object({
  name: yup.string().required("Bank Card Type Name is required"),
});

const AddBankCard = ({ id, onClose, open, setOpen }) => {
  const formikRef = useRef();
  const dialogRef = useRef();
  const navigate = useNavigate();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);

  useEffect(() => {
    setIsFormikInitialized(open);
  }, [open]);

  const onSubmitData = async (d, action) => {
    let data = {
      ...d,
      id,
    };
    let response = await Common.ApiService.getInstance().request(
      "AddUpdateBankCardType",
      data,
      "POST"
    );
    action.setSubmitting(false);
    if (response.status === respEnum.Success) {
      onClose(response.data);
      setOpen(false);
      if (!onClose) {
        navigate("/app/bankcards", { replace: true });
      }
    }
  };

  const getDataInfo = async () => {
    let response = await Common.ApiService.getInstance().request(
      `GetBankCardType?id=${id}`
    );
    if (response.status === respEnum.Success && response.data.length > 0) {
      formikRef.current.setValues(response.data[0]);
    }
  };

  useEffect(() => {
    if (id) {
      getDataInfo();
    }
  }, [id]);

  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            size="sm"
            variant="primary"
            className="flex items-center gap-2"
          >
            <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
            Add
          </Button>
        </DialogTrigger>
        <DialogContent
          ref={dialogRef}
          className="max-h-[100vh] overflow-y-auto sm:max-w-[425px]"
        >
          <DialogHeader>
            <DialogTitle className="text-base font-medium">
              {!id ? "Add" : "Update"} Bank Card Type
            </DialogTitle>
          </DialogHeader>

          <div className="text-sm text-default-500 space-y-2">
            <Formik
              innerRef={formikRef}
              onSubmit={onSubmitData}
              initialValues={FormikInitialValues}
              validationSchema={formikValidation}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(formikProps) => (
                <div className="flex flex-col gap-4">
                  <FormikInput
                    formikProps={formikProps}
                    name={"name"}
                    label={"Bank Card Type Name"}
                    placeholder={"Enter Bank Card Type Name"}
                  />
                  <FormikCheckbox
                    formikProps={formikProps}
                    name={"isactive"}
                    label={"Is Active"}
                  />
                </div>
              )}
            </Formik>
          </div>

          <DialogFooter className="mt-6">
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Close
              </Button>
            </DialogClose>
            {isFormikInitialized && formikRef.current && (
              <Button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  formikRef.current?.handleSubmit();
                }}
              >
                {formikRef.current.isSubmitting
                  ? "Saving..."
                  : !id
                  ? "Add"
                  : "Update"}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddBankCard;
